import { useEffect } from "react";
import { DEFAULT_PAGE_TITLE, routesConfig } from "config/app-config";
import { matchRoutes, useLocation } from "react-router";

const tempRoutes = Object.keys(routesConfig).map((v) => ({
  path: routesConfig[v].path,
  element: routesConfig[v].title,
}));

/** Ce composant change le title de la page selon le routing dans routesConfig */
export function useTitle(): void {
  const location = useLocation();

  useEffect(() => {
    const match = matchRoutes(tempRoutes, location);
    let title: string | undefined;
    if (match != null) {
      title = match[0]?.route?.element;
    }
    document.title = title ?? DEFAULT_PAGE_TITLE;
  }, [location]);
}
